export default "__VITE_ASSET__CDIyld8i__"